import React from "react";
import PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Config from "conFig.js";
import "suneditor/dist/css/suneditor.min.css";
const Listfileuploaded = React.memo(function Listfileuploaded(props) {
  const { fileid, xoafile } = props;
  const xoa = (id) => {
    xoafile(id);
  };
  const reviewfile = (id) => {
    window.open("https://docs.google.com/viewer?url=" + Config.link + id);
  };
  return (
    <FormControl style={{ width: "99%", marginTop: "10px", marginLeft: "4px" }}>
      {fileid.map((prop, i) => {
        return (
          <div key={i} style={{ display: "flex" }}>
            <li key={i}>
              {prop.filename}
              <Button
                color="error"
                variant="contained"
                onClick={() => xoa(prop.id)}
                style={{ height: "20px", marginLeft: "15px" }}
              >
                Xóa file
              </Button>
              <Button
                color="success"
                variant="contained"
                onClick={() => reviewfile(prop.id)}
                style={{ height: "20px", marginLeft: "15px" }}
              >
                Xem file
              </Button>
            </li>
          </div>
        );
      })}
    </FormControl>
  );
});

Listfileuploaded.propTypes = {
  fileid: PropTypes.array,
  xoafile: PropTypes.func,
};
export default Listfileuploaded;
